
import Firebase from 'firebase'
let config = {
    apiKey: "AIzaSyD6u_r5c33oA13Xkmy-QqWaMQFagpUoxX8",
    authDomain: "mdanonymous.firebaseapp.com",
    projectId: "mdanonymous",
    storageBucket: "mdanonymous.appspot.com",
    messagingSenderId: "321751666869",
    appId: "1:321751666869:web:98b1b245e18947f7776efc",
    measurementId: "G-YBGHH6T13G"
  };

  export default !Firebase.apps.length ? Firebase.initializeApp(config) : Firebase.app();
  export const db =  !Firebase.apps.length ? Firebase.initializeApp(config) : Firebase.firestore();
  export const firestorage =  !Firebase.apps.length ? Firebase.initializeApp(config) : Firebase.storage();
  export const firestore = !Firebase.apps.length ? Firebase.initializeApp(config) : Firebase.firestore();